var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55549 17.0926C3.55549 9.72876 9.52503 3.75923 16.8888 3.75923C24.2526 3.75923 30.2222 9.72876 30.2222 17.0926C30.2222 24.4564 24.2526 30.4259 16.8888 30.4259C9.52503 30.4259 3.55549 24.4564 3.55549 17.0926ZM16.8888 0.796265C7.88863 0.796265 0.592529 8.09237 0.592529 17.0926C0.592529 26.0928 7.88863 33.3889 16.8888 33.3889C25.889 33.3889 33.1851 26.0928 33.1851 17.0926C33.1851 8.09237 25.889 0.796265 16.8888 0.796265ZM19.4179 11.6006L23.8623 16.045C24.4409 16.6236 24.4409 17.5616 23.8623 18.1401L19.4179 22.5846C18.8393 23.1631 17.9013 23.1631 17.3227 22.5846C16.7442 22.006 16.7442 21.068 17.3227 20.4894L19.2381 18.574H10.9629C10.1447 18.574 9.48142 17.9108 9.48142 17.0926C9.48142 16.2744 10.1447 15.6111 10.9629 15.6111H19.2381L17.3227 13.6957C16.7442 13.1171 16.7442 12.1791 17.3227 11.6006C17.9013 11.022 18.8393 11.022 19.4179 11.6006Z",
    fill: "#407BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.39d8fc3b.svg";
export { ForwardRef as ReactComponent };